interface IProps {
  progress?:any,
  'data-attribute'?: any,
}
const Progress_bar = ({progress, 'data-attribute': dataAttribute}:IProps) => {   
    const Parentdiv = {
        height: '5px',
        width: '100%',
        backgroundColor: 'whitesmoke',
        borderRadius: '10px',
      }
      
      const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: '#0072CE',
        borderRadius:'10px'
      }
      
      const progresstext = {
        padding: '10px',
        color: 'black',
        fontWeight: 900
      }   
    return (
    <div style={Parentdiv} data-attribute={dataAttribute}>
      <div style={Childdiv}>
        <span style={progresstext}></span>
      </div>
    </div>
    )
}
  
export default Progress_bar;